import cn from 'clsx'
import { useLocation } from 'react-router'

// Components
import { Link, IconFavoriteOutline, IconPurchasedTracksOutline } from '@tracklib/kit'

import styles from './yourlibrary.css'

const items = [
  {
    text: 'Purchased Tracks',
    url: '/purchasedtracks/',
    icon: <IconPurchasedTracksOutline className={styles.iconPurchasedTracks} />,
  },
  {
    text: 'Favorites',
    url: '/favorites/',
    icon: <IconFavoriteOutline className={styles.iconFavorite} />,
  },
]

const YourLibrary = () => {
  const { pathname } = useLocation()
  return (
    <ul className={styles.wrapper}>
      {items.map(({ url, text, icon }) => (
        <li key={url} className={cn(styles.item, pathname === url && styles.active)}>
          <Link to={url}>
            <span className={styles.icon}>{icon}</span> {text}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default YourLibrary
